/**
 * AlarmDrawer.jsx
 * Drawer lateral con historial de alarmas y eventos
 */

import {
    Box, Drawer, IconButton, List, ListItem, ListItemIcon,
    ListItemText, Stack, Tooltip, Typography,
} from "@mui/material";
import {
    CheckCircle as CheckCircleIcon,
    Close as CloseIcon,
    DeleteSweep as DeleteSweepIcon,
    Error as ErrorIcon,
    Info as InfoIcon,
    Warning as WarningIcon,
} from "@mui/icons-material";

const SEV_ICON = {
    danger: <ErrorIcon color="error" fontSize="small" />,
    warn: <WarningIcon color="warning" fontSize="small" />,
    info: <InfoIcon color="info" fontSize="small" />,
    ok: <CheckCircleIcon color="success" fontSize="small" />,
};

export default function AlarmDrawer({ open, alarms, onClear, onClose }) {
    return (
        <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: 320 } }}>
            {/* Header */}
            <Stack
                direction="row" alignItems="center" justifyContent="space-between"
                sx={{ p: 2, borderBottom: 1, borderColor: "divider" }}
            >
                <Typography variant="subtitle2" fontWeight={600}>
                    Alarmas y eventos
                </Typography>
                <Stack direction="row" gap={0.5}>
                    <Tooltip title="Limpiar todo">
                        <IconButton size="small" onClick={onClear}>
                            <DeleteSweepIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                    <IconButton size="small" onClick={onClose}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Stack>
            </Stack>

            {/* Lista */}
            {alarms.length === 0 ? (
                <Box sx={{ p: 4, textAlign: "center" }}>
                    <CheckCircleIcon color="success" sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="body2" color="text.secondary">
                        Sin alarmas activas
                    </Typography>
                </Box>
            ) : (
                <List dense disablePadding>
                    {alarms.map((a) => (
                        <ListItem key={a.id} divider alignItems="flex-start">
                            <ListItemIcon sx={{ minWidth: 32, mt: 0.5 }}>
                                {SEV_ICON[a.sev]}
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <>
                                        <Typography component="span" variant="body2" fontWeight={600}>
                                            {a.tank}
                                        </Typography>
                                        <Typography component="span" variant="caption" color="text.disabled" sx={{ ml: 1 }}>
                                            {a.hora}
                                        </Typography>
                                    </>
                                }
                                secondary={
                                    <Typography variant="caption">{a.msg}</Typography>
                                }
                            />
                        </ListItem>
                    ))}
                </List>
            )}
        </Drawer>
    );
}